<template>
  <div class="productRecommend" v-if="nav.list.length">
    <!-- 一级分类 -->
    <tabs
      class="productRecommend-mainTabs"
      :list="nav.list"
      :type="1"
      @change="mainTabsChange"
    ></tabs>

    <!-- 二级分类 -->
    <tabs
      class="productRecommend-subTabs"
      :children="nav.list[nav.mainIndex].children"
      :type="2"
      @change="subTabsChange"
      :i="nav.subIndex"
    ></tabs>

    <!-- 搜索 -->
    <form class="productRecommend-searchInfo" @submit.prevent="searchSubmit()">
      <input
        class="productRecommend-searchInfo-input"
        v-model="searchkey"
        placeholder="搜一搜查询您想要的产品"
      />
      <div class="productRecommend-searchInfo-button" @click="searchSubmit()">
        搜索
      </div>
    </form>

    <!-- 产品 -->
    <div class="productRecommend-goods" v-if="goods.length" :key="goods">
      <div class="productRecommend-goods-detail">
        <swiper
          class="productRecommend-goods-detail-swiper"
          loop
          virtual
          @swiper="swiperInit('detail', $event)"
        >
          <swiper-slide
            class="productRecommend-goods-detail-swiper-slide swiper-no-swiping"
            v-for="item in goods"
            :key="item.id"
          >
            <div class="productRecommend-goods-detail-item">
              <video
                class="productRecommend-goods-detail-item-cover"
                v-if="item.videofile"
                :key="item.id"
                controls
                :poster="item.videoimages"
              >
                <source :src="item.videofile" type="video/mp4" />
              </video>
              <div
                v-else
                class="productRecommend-goods-detail-item-cover"
                :style="{
                  '--pc': `url(${item.webimages || item.images})`,
                  '--mobile': `url(${item.mobileimages || item.images})`,
                }"
              ></div>
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <div class="productRecommend-goods-thumbs">
        <swiper
          :slidesPerView="3"
          centeredSlides
          loop
          @swiper="swiperInit('thumbs', $event)"
          @slideChange="thumbsChange"
          class="productRecommend-goods-thumbs-swiper"
        >
          <swiper-slide
            class="productRecommend-goods-thumbs-swiper-slide"
            v-for="item in goods"
            :key="item.id"
          >
            <div class="productRecommend-goods-thumbs-item">
              <router-link
                class="productRecommend-goods-thumbs-item-router"
                :to="{ name: 'productDetail', query: { id: item.id } }"
              >
                <img
                  class="productRecommend-goods-thumbs-item-cover"
                  :src="item.images"
                />
                <div class="productRecommend-goods-thumbs-item-title">
                  {{ item.name }}
                </div>
              </router-link>
            </div>
          </swiper-slide>

          <template #container-start>
            <div
              class="productRecommend-goods-thumbs-swiper-next"
              @click="swiper.thumbs?.slideNext()"
            ></div>
            <div
              class="productRecommend-goods-thumbs-swiper-prev"
              @click="swiper.thumbs?.slidePrev()"
            ></div>
          </template>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import tabs from "./tabs.vue";

export default {
  components: { tabs },
  data() {
    return {
      nav: {
        list: [],
        mainIndex: 0,
        subIndex: 0,
      },

      goods: [],

      swiper: {
        thumbs: null,
        detail: null,
      },

      searchkey: "",
    };
  },
  mounted() {
    // 初始化数据
    this.init();
  },
  methods: {
    /**
     * 初始化数据
     */
    async init() {
      try {
        // 获取主导航
        const result = await this.$request.get("/Khindex/StarProductsNav");

        // 设置数据
        this.nav.list = result.data;

        //
        this.getData(
          this.nav.list[this.nav.mainIndex].children[this.nav.subIndex].id
        );
      } catch (e) {
        // 错误状态
        this.$message.error(e.message);
      }
    },

    /**
     * 主菜单变更
     */
    mainTabsChange(mainIndex) {
      this.nav.mainIndex = mainIndex;
      this.subTabsChange(0);
    },

    /**
     * 次菜单变更
     */
    subTabsChange(subIndex) {
      this.nav.subIndex = subIndex;
      this.getData(
        this.nav.list[this.nav.mainIndex].children[this.nav.subIndex].id
      );
    },

    /**
     *
     */
    swiperInit(swiper, e) {
      this.swiper[swiper] = e;
    },

    thumbsChange(e) {
      this.swiper.detail.slideTo(e.realIndex);
    },

    /**
     * 获取数据
     */
    async getData(nav_id) {
      try {
        // 获取主导航
        const result = await this.$request.get("/Khindex/StarProducts", {
          params: {
            nav_id,
          },
        });

        // 设置数据
        this.goods = result.data;

        //
        // await this.$nextTick();
        // this.swiper.detail?.update();
        // this.swiper.thumbs?.update();
        // await this.$nextTick();
        // this.swiper.detail?.slideToLoop(0);
        // this.swiper.thumbs?.slideToLoop(0);
      } catch (e) {
        // 错误状态
        this.$message.error(e.message);
      }
    },

    searchSubmit() {
      this.$router.push({
        name: "searchProduct",
        query: { search: this.searchkey },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.productRecommend {
  %animation {
    transition-property: top, left, height;
    transition-duration: 500ms;
  }

  @extend %animation;
  position: relative;
  background-size: 300px 100px, cover;
  background-position: center 115px, center;
  background-repeat: no-repeat;
  background-image: url("~@/assets/image/home/title.png"),
    url("~@/assets/image/home/recommend_bg.png");
  height: 936px;

  &-mainTabs {
    @extend %animation;
    position: absolute;
    top: 260px;
    left: 0;
    right: 0;
    margin: auto;
    width: fit-content;
  }

  &-subTabs {
    @extend %animation;
    position: absolute;
    top: 360px;
    left: 0;
    right: 0;
    margin: auto;
    width: fit-content;
  }

  &-searchInfo {
    @extend %animation;
    width: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 440px;

    &-input {
      width: 386px;
      height: 48px;
      border: 1px solid #dfdfdf;
      border-radius: 24px;
      display: flex;
      align-items: center;
      outline: none;
      padding: 0;
      padding-left: 64px;
      color: #030303;
      font-size: 18px;
      background-color: #ffffff;

      background-image: url("@/assets/image/header/ic_search.png");
      background-size: 48px;
      background-repeat: no-repeat;
      background-position-y: center;
      background-position-x: 14px;

      &::-webkit-input-placeholder {
        color: #c9c9c9;
      }
    }

    &-button {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 23px;
      width: 184px;
      height: 50px;
      background-color: #ee7800;
      border-radius: 24px;
      color: #fff;
      font-size: 16px;

      &:active {
        background-color: rgba(210, 217, 236, 0.878);
      }
    }
  }

  // 商品
  &-goods {
    @extend %animation;
    @include fn.container;
    position: absolute;
    top: 616px;
    left: 0;
    right: 0;
    margin: auto;
    height: 320px;

    &-detail {
      @extend %animation;
      position: absolute;
      top: 0;
      left: 0;
      @include fn.scale(520px);

      &-item {
        @include fn.scale(500px);
        margin: 0 10px;
        display: block;

        &-cover {
          @include fn.cover;
          background-position: center;
          background-size: cover;
          background-image: var(--pc);
        }
      }
    }

    &-thumbs {
      @extend %animation;
      position: absolute;
      top: 20px;
      left: 520px;
      width: 690px;

      %button {
        cursor: pointer;
        position: absolute;
        background-size: 100%;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 20px;
        height: 20px;
        z-index: 11;
      }

      &-swiper {
        &-next {
          @extend %button;
          right: 10px;
          background-image: url("~@/assets/image/home/ic_right.png");
        }

        &-prev {
          @extend %button;
          left: 10px;
          background-image: url("~@/assets/image/home/ic_left.png");
        }
      }

      &-item {
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 500ms;

        &-router {
          width: 139px;
          margin: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: all 500ms;
        }

        &-cover {
          @include fn.scale(139px);
        }

        &-title {
          width: 100px;
          height: 26px;
          line-height: 26px;
          padding: 0 20px;
          overflow: hidden;
          text-align: center;
          border: 1px solid #cac8c7;
          border-radius: 13px;
          margin: auto;
          margin-top: 10px;
          font-size: 18px;
          transition: all 250ms;
        }
      }

      &::v-deep(.swiper-slide-active) &-item {
        transform: scale(1.4);

        &-title {
          background-color: color.$base;
          color: #fff;
          border-color: transparent;
        }
      }
    }
  }
}
</style>


<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
  .productRecommend {
    background-size: fn.rpx(300) fn.rpx(100), cover;
    background-position: center fn.rpx(115), center;
    background-image: url("~@/assets/image/home/title.png"),
      url("~@/assets/image/home/m_recommend_bg.png");
    height: fn.rpx(1200);

    &-mainTabs {
      top: fn.rpx(260);
    }

    &-subTabs {
      top: fn.rpx(360);
    }

    &-searchInfo {
      top: fn.rpx(440);

      &-input {
        width: fn.rpx(300);
        height: fn.rpx(48);
        border: fn.rpx(2) solid #dfdfdf;
        border-radius: fn.rpx(24);
        padding-left: fn.rpx(64);
        font-size: fn.rpx(18);

        background-size: fn.rpx(48);
        background-position-x: fn.rpx(14);
      }

      &-button {
        margin-left: fn.rpx(24);
        width: fn.rpx(184);
        height: fn.rpx(50);
        border-radius: fn.rpx(24);
        font-size: fn.rpx(16);
      }
    }

    // 商品
    &-goods {
      top: fn.rpx(538);
      height: fn.rpx(660);

      &-detail {
        left: 0;
        right: 0;
        margin: auto;
        @include fn.scale(fn.rpx(640));

        &-item {
          @include fn.scale(fn.rpx(620));
          margin: 0 10px;

          &-cover {
            @include fn.cover;
            background-image: var(--mobile);
          }
        }
      }

      &-thumbs {
        top: fn.rpx(340);
        left: fn.rpx(0);
        right: fn.rpx(0);
        margin: auto;
        width: fn.rpx(700);

        %button {
          margin: auto;
          width: fn.rpx(20);
          height: fn.rpx(20);
        }

        &-swiper {
          &-next {
            @extend %button;
          }

          &-prev {
            @extend %button;
          }
        }

        &-item {
          height: fn.rpx(300);

          &-router {
            width: fn.rpx(200);
          }

          &-cover {
            @include fn.scale(fn.rpx(139));
          }

          &-title {
            width: fn.rpx(100);
            height: fn.rpx(26);
            line-height: fn.rpx(26);
            padding: 0 fn.rpx(20);
            border: fn.rpx(2) solid #cac8c7;
            border-radius: fn.rpx(13);
            margin-top: fn.rpx(10);
            font-size: fn.rpx(18);
          }
        }

        &::v-deep(.swiper-slide-active) &-item {
          transform: scale(1.4);
        }
      }
    }
  }
}
</style>